﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCreateVehiclesTypes = void 0;
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const StateVehiclesTypes_1 = require("./StateVehiclesTypes");
class StateCreateVehiclesTypes extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageVehiclesType, "New vehicles type", true);
        this.page.ctrls.btnSave.onclick = () => this.trySave();
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.start.call(this);
        });
    }
    trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            var data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            data.size = new models_1.Size(data);
            const req = new models_1.CreateVehicleTypeRequest(data);
            req.name.en = data.name_en;
            req.name.de = data.name_de;
            req.description.en = data.description_en;
            req.description.de = data.description_de;
            req.descriptionShort.en = data.descriptionShort_en;
            req.descriptionShort.de = data.descriptionShort_de;
            const vtype = yield this.lockgui(this.app.api.admin.directory.createVehicleType(req));
            if (!vtype)
                return;
            yield gs_1.StateGS.Run(StateVehiclesTypes_1.StateVehiclesTypes);
        });
    }
}
exports.StateCreateVehiclesTypes = StateCreateVehiclesTypes;
StateCreateVehiclesTypes.StateName = "newVehiclesType";
//# sourceMappingURL=StateCreateVehiclesTypes.js.map